// ** Dropdowns Imports
import { Fragment } from 'react'
import IntlDropdown from './IntlDropdown'
import themeConfig from '@configs/themeConfig'
import { Link } from 'react-router-dom'


// ** Third Party Components
import { Sun, Moon, Menu } from 'react-feather'
import { NavItem, NavLink, Button } from 'reactstrap'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <Fragment>
      {/* Menu Mobile*/}
      <ul className='navbar-nav d-xl-none d-flex align-items-center'>
        <NavItem className='mobile-menu mr-auto'>
          <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuVisibility(true)}>
            <Menu className='ficon' />
          </NavLink>
        </NavItem>
      </ul>

      {/* logo */}
      <ul className='navbar-nav'>
      <NavItem className='mobile-menu mr-auto'> 
      <div className='navbar-header navbar-fixed align-items-center navbar-brand-center mr-auto d-none d-sm-block'>
      <Link to='/home'><img src={themeConfig.app.appLogoImage} width='110' alt='logo' /></Link>
      </div>
      {/* logo mobile */}
      <div className='d-block d-sm-none'>
      <Link to='/home'><img src={themeConfig.app.appLogoImage} style={{ float: 'top', display: 'block', width: '40%', marginLeft: 'auto', marginRight: 'auto', borderRadius: '1%' }} /></Link>
      </div>
      </NavItem>
      </ul>

      {/* Dark mode */}
      <div className='bookmark-wrapper d-flex align-items-center'>
        <NavItem className='d-none d-lg-block'>
          <NavLink className='nav-link-style'>
            <ThemeToggler />
          </NavLink>
        </NavItem>
      </div>

     {/* Switch Language */}
      <ul className='nav navbar-nav align-items-center ml-auto'>
        <IntlDropdown />
      </ul>
    </Fragment>
  )
}
export default NavbarUser
